import { withInstall, withNoopInstall } from '@bigin/utils'
import Button from './src/button.vue'
import ButtonGroup from './src/button-group.vue'

export const BButton = withInstall(Button, {
  ButtonGroup,
})
export const BButtonGroup = withNoopInstall(ButtonGroup)
export default BButton

export * from './src/button'
